import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic } from '@fortawesome/free-solid-svg-icons/faMusic';
import type { IconProps } from '../../types';

export function MusicIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Music',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faMusic}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
